import React, { useEffect, useState } from "react";

import Header from "../components/header";
import Footer from "../components/footer";
import BannerTop from "./components/bannertop";
import TutorialNav from "./components/tutorialnav";

import payment_web1 from "../../static/images/tutorial/tutorialWeb4/tutorialWeb-4.1.png";
import payment_web2 from "../../static/images/tutorial/tutorialWeb4/tutorialWeb-4.2.png";
import payment_web3 from "../../static/images/tutorial/tutorialWeb4/tutorialWeb-4.3.png";
import payment_web4 from "../../static/images/tutorial/tutorialWeb4/tutorialWeb-4.4.png";
import payment_web5 from "../../static/images/tutorial/tutorialWeb4/tutorialWeb-4.5.png";
import payment_web6 from "../../static/images/tutorial/tutorialWeb4/tutorialWeb-4.6.png";

import { IcMinusGreen, IcPlus } from "../common/svg";

const PaymentHowTo = (props) => {
	const [activeTab, setActiveTab] = useState("#website");
	const [isMobile, setIsMobile] = useState(false);
	const [showDetail, setShowDetail] = useState({});

	const toggleShowDetail = (i) => {
		setShowDetail({
			...showDetail,
			[i]: !showDetail[i],
		});
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		setActiveTab(props.location.hash || "#website");
		setIsMobile(props.location.pathname.includes("/mobile"));
	}, []);

	return (
		<div className="mioto-layout">
			{!isMobile && <Header />}
			<section className="body">
				<div className="tutorial-page">
					<BannerTop title={`Hướng dẫn & Quy&nbsp;chế`} />
					<div className="tutorial-main space sec" id={activeTab === "#website" ? "website" : "app"}>
						<div className="m-container">
							<TutorialNav isMobile={isMobile} active="Hướng dẫn thanh toán" />
							<div className="tutorial-content">
								<div className="category-option">
									<h4>Hướng dẫn thanh toán</h4>
									{/* <div className="category-type">
										<a
											href="#website"
											onClick={() => setActiveTab("#website")}
											className={`btn btn-type ${activeTab === "#website" ? "active" : ""}`}>
											Website
										</a>
										<a
											href="#app"
											onClick={() => setActiveTab("#app")}
											className={`btn btn-type ${activeTab === "#app" ? "active" : ""}`}>
											App
										</a>
									</div> */}
								</div>
								{/* <div className="tutorial-payment-method">
									<div className="tutorial-payment-method--wrap">
										<div className="payment-method--item active">
											<div className="num-method">1</div>
											<p>Thanh toán qua thẻ của tôi</p>
										</div>
										<div className="payment-method--item">
											<div className="num-method">2</div>
											<p>Thanh toán trực tuyến - Ví điện tử</p>
										</div>
										<div className="payment-method--item">
											<div className="num-method">3</div>
											<p>Thanh toán qua thẻ tín dụng / thẻ ghi nợ</p>
										</div>
										<div className="payment-method--item">
											<div className="num-method">4</div>
											<p>Thanh toán qua thẻ ATM đã đăng ký</p>
										</div>
									</div>
								</div> */}
								<div className="main-content">
									<div
										className={`main-place pointer ${showDetail[0] ? "text-primary" : ""}`}
										onClick={() => toggleShowDetail(0)}>
										<h6>1. Thanh toán qua thẻ của&nbsp;tôi</h6>
										<div className="wrap-svg">{showDetail[0] ? <IcMinusGreen /> : <IcPlus />}</div>
									</div>
									{showDetail[0] && (
										<>
											<p>
												Bạn cần có thẻ Visa credit, Master credit để thanh toán bằng hình thức này. Các bước thực hiện
												khá đơn giản:
												<br />
												Chọn thẻ credit bạn đã thêm tại Thẻ của tôi hoặc Thêm thẻ để thanh toán
											</p>
											<img loading="lazy" src={payment_web1} />
										</>
									)}
									<div
										className={`main-place pointer ${showDetail[1] ? "text-primary" : ""}`}
										onClick={() => toggleShowDetail(1)}>
										<h6>2. Thanh toán trực tiếp - Ví điện&nbsp;tử</h6>
										<div className="wrap-svg">{showDetail[1] ? <IcMinusGreen /> : <IcPlus />}</div>
									</div>
									{showDetail[1] && (
										<>
											<p>
												Bạn cần có tài khoản 1 trong 2 ví điện tử phía dưới để thanh toán bằng hình thức này. Các bước
												thực hiện khá đơn giản:
												<br />
												Chọn 1 trong 2 ví điện tử Momo hoặc VNPay - Bấm thanh toán để chuyển đến ví điện tử - Nhập các
												thông tin tài khoản hoặc quét mã thanh toán.
											</p>
											<img loading="lazy" src={payment_web2} />
										</>
									)}
									<div
										className={`main-place pointer ${showDetail[2] ? "text-primary" : ""}`}
										onClick={() => toggleShowDetail(2)}>
										<h6>3. Thanh toán qua thẻ tín dụng/thẻ ghi nợ VISA,&nbsp;Master</h6>
										<div className="wrap-svg">{showDetail[2] ? <IcMinusGreen /> : <IcPlus />}</div>
									</div>
									{showDetail[2] && (
										<>
											<p>
												Bạn cần có thẻ Visa, Master để thanh toán bằng hình thức này. Các bước thực hiện khá đơn giản:
												<br />
												Chọn cổng thanh toán - Bấm thanh toán để chuyển đến cổng thanh toán - Nhập các thông tin trên
												thẻ và hoàn tất quá trình thanh toán.
											</p>
											<img loading="lazy" src={payment_web3} />
										</>
									)}
									<div
										className={`main-place pointer ${showDetail[3] ? "text-primary" : ""}`}
										onClick={() => toggleShowDetail(3)}>
										<h6>4. Thanh toán qua thẻ ATM đã đăng kí thanh toán trực&nbsp;tuyến</h6>
										<div className="wrap-svg">{showDetail[3] ? <IcMinusGreen /> : <IcPlus />}</div>
									</div>
									{showDetail[3] && (
										<>
											<p>
												Thẻ của bạn phải đăng ký dịch vụ thanh toán trực tuyến với ngân hàng để thực hiện thanh toán
												bằng hình thức này.
												<br />
												Chọn cổng thanh toán VNPay - Bấm thanh toán để chuyển đến cổng thanh toán - Nhập các thông tin
												trên thẻ và hoàn tất quá trình thanh toán.
											</p>
											<img loading="lazy" src={payment_web4} />
										</>
									)}
									<div
										className={`main-place pointer ${showDetail[4] ? "text-primary" : ""}`}
										onClick={() => toggleShowDetail(4)}>
										<h6>5. Thanh toán bằng hình thức chuyển khoản ngân&nbsp;hàng</h6>
										<div className="wrap-svg">{showDetail[4] ? <IcMinusGreen /> : <IcPlus />}</div>
									</div>
									{showDetail[4] && (
										<>
											<p>
												Trước tiên, bạn cần bấm "Đặt chỗ" để xác nhận hình thức thanh toán chuyển khoản. Sau đó, tiến
												hành chuyển khoản qua tài khoản ngân hàng của Mioto trong thời gian sớm nhất bạn nhé.
											</p>
											<img loading="lazy" src={payment_web5} />
										</>
									)}
									<div
										className={`main-place pointer ${showDetail[5] ? "text-primary" : ""}`}
										onClick={() => toggleShowDetail(5)}>
										<h6>6. Thanh toán bằng hình thức dùng thẻ quà (voucher)</h6>
										<div className="wrap-svg">{showDetail[5] ? <IcMinusGreen /> : <IcPlus />}</div>
									</div>
									{showDetail[5] && (
										<>
											<p>
												Chọn phương thức thanh toán dùng thẻ quà, chọn nhà cung cấp tương ứng sau đó nhập mã thanh toán.
												Lưu ý, bạn có thể kế hợp với các phương thức thanh toán khác nếu mã thanh toán không đủ.
											</p>
											<img loading="lazy" src={payment_web6} />
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{!isMobile && <Footer />}
		</div>
	);
};

export default PaymentHowTo;
